import { render, staticRenderFns } from "./HomeStudentsDraw.vue?vue&type=template&id=8fc8dfdc&scoped=true&"
import script from "./HomeStudentsDraw.vue?vue&type=script&lang=js&"
export * from "./HomeStudentsDraw.vue?vue&type=script&lang=js&"
import style0 from "./HomeStudentsDraw.vue?vue&type=style&index=0&id=8fc8dfdc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc8dfdc",
  null
  
)

export default component.exports